// import { appGroups } from "constants/brandings";
import { useMemo } from "react";
import { appGroups } from "../constants/brandings";

// try to send search from useLocation as a param 
export const generateAppid = (search = window.location.search) => {
  const getAppidFromQueryParam = () => {
    const queryparams = new URLSearchParams(search);
    const appidFromQuery = queryparams.get("appid") || queryparams.get("appId");
    return appidFromQuery;
  };

  const appid = getAppidFromQueryParam();

  const configObj = {
    appid,
    // isVitalityAppid: appGroups?.VITALITY_APPIDS.split(",").includes(appid),
    // isSprntAppid: appGroups.SPRNT_APPIDS.split(",").includes(appid),
    // isDTCPIAppid: appGroups.DTC_PI_APPIDS.split(",").includes(appid),
    isUsrB2bPortalAppid: appGroups?.B2B_PORTAL_APPIDS?.split(",").includes(appid),
    isUsrB2cPortalAppid: appGroups?.B2C_PORTAL_APPIDS?.split(",").includes(appid),
    isProviderAppid: appGroups?.PROVIDER_APPIDS?.split(",").includes(appid),
  };

  return configObj;
};

const useAppids = () => {

  const generateAppidLoc = useMemo(() => {
    const details = generateAppid();
    return details;
  }, [window.location.search]);

  return generateAppidLoc;
};

export default useAppids;
